import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { kittens, KittenStatus } from "../data/content";
import { Reveal } from "./Reveal";
type Filter = "Tous" | KittenStatus;
const filters: Filter[] = ["Tous", "Disponible", "Réservé"];
export function Kittens() {
  const [filter, setFilter] = useState<Filter>("Tous");
  const visible = kittens.filter(k => filter === "Tous" || k.status === filter);
  const available = kittens.filter(k => k.status === "Disponible").length;
  return <section id="chatons" className="bg-ink py-24 lg:py-36" data-id="element-146" data-mp="1ahi26a1ac0jb">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-147" data-mp="15gu08tbipzab">
        <Reveal className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-148" data-mp="15f9634t48icz">
          <div className="lg:col-span-7" data-id="element-149" data-mp="10gzait3hbfqu">
            <p className="text-sm text-sage" data-id="element-150" data-mp="10k3ky87jf7py">Portée d'août 2026 · {available} chatons disponibles</p>
            <h2 className="mt-4 font-display text-4xl text-cream sm:text-5xl lg:text-6xl" data-id="element-151" data-mp="3q58e1ea5urfl">
              Nos <span className="italic text-sage" data-id="element-152" data-mp="3lackg9p9zw0d">chatons</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:flex lg:justify-end" data-id="element-153" data-mp="2dm0cngyxohz6">
            <div role="tablist" aria-label="Filtrer les chatons" className="inline-flex rounded-full border border-line p-1" data-id="element-154" data-mp="2im4vhdnbdosk">
              {filters.map(f => <button key={f} role="tab" aria-selected={filter === f} onClick={() => setFilter(f)} className={`relative rounded-full px-5 py-2 text-sm transition-colors duration-150 ${filter === f ? "text-ink" : "text-stone hover:text-cream"}`} data-id="element-155" data-mp="28oqe9btkgvz7">
                  {filter === f && <motion.span layoutId="kitten-filter" className="absolute inset-0 rounded-full bg-sage" transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-156" data-mp="1pzk104bjkwks" />}
                  <span className="relative" data-id="element-157" data-mp="3ini2yr6b7nxt">{f === "Tous" ? f : `${f}s`}</span>
                </button>)}
            </div>
          </div>
        </Reveal>

        <motion.ul layout className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-158" data-mp="3dugkk96w969h">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-159" data-mp="38uu6xyn5lo05">
            {visible.map(k => <motion.li key={k.name} layout initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.96
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col" data-id="element-160" data-mp="33w955us96w9l">
                <div className="relative overflow-hidden rounded-sm bg-coal" data-id="element-161" data-mp="3nlb7lfrys9vz">
                  <img src={k.image} alt={`Chaton Bengal ${k.sex.toLowerCase()} ${k.name}, robe ${k.coat}`} className={`aspect-[4/5] w-full object-cover ${k.status === "Réservé" ? "opacity-60 grayscale-[40%]" : ""}`} data-id="element-162" data-mp="2g8riuerrcqe0" />
                  <span className={`absolute left-4 top-4 rounded-full px-3 py-1 text-xs font-medium ${k.status === "Disponible" ? "bg-sage text-ink" : "bg-ink/80 text-cream"}`} data-id="element-163" data-mp="vpp7llbvjkqs">
                    {k.status}
                  </span>
                </div>
                <div className="mt-5 flex items-baseline justify-between" data-id="element-164" data-mp="1af3i4wr6s87r">
                  <h3 className="font-display text-3xl text-cream" data-id="element-165" data-mp="1fd4z9c51xxgl">{k.name}</h3>
                  <span className="text-sm text-stone" data-id="element-166" data-mp="1jft8hkxoh6e3">{k.sex}</span>
                </div>
                <dl className="mt-3 space-y-1 border-t border-line pt-3 text-sm text-stone" data-id="element-167" data-mp="1ofo0jrt6w20q">
                  <div className="flex justify-between" data-id="element-168" data-mp="3l7o8h3aknmgh">
                    <dt data-id="element-169" data-mp="3l98z4htrml92">Robe</dt>
                    <dd className="text-cream/80" data-id="element-170" data-mp="3q6974ya6dy2t">{k.coat}</dd>
                  </div>
                  <div className="flex justify-between" data-id="element-171" data-mp="3q8c3s15u2pgi">
                    <dt data-id="element-172" data-mp="2uv18484relar">Parents</dt>
                    <dd className="text-cream/80" data-id="element-173" data-mp="2uy5nm1nod3gq">{k.parents}</dd>
                  </div>
                </dl>
                {k.status === "Disponible" ? <a href={`#contact`} className="mt-5 inline-flex justify-center rounded-full border border-sage/40 py-3 text-sm text-sage transition-colors duration-150 hover:bg-sage hover:text-ink" data-id="element-174" data-mp="34t7byva4m1i9">
                    Demander {k.name}
                  </a> : <span className="mt-5 inline-flex justify-center rounded-full border border-line py-3 text-sm text-stone" data-id="element-175" data-mp="274x788iygzng">
                    A trouvé sa famille
                  </span>}
              </motion.li>)}
          </AnimatePresence>
        </motion.ul>

        {visible.length === 0 && <p className="mt-14 text-center text-stone" data-id="element-176" data-mp="1ogs5f6luzora">Aucun chaton dans cette catégorie pour le moment.</p>}
      </div>
    </section>;
}